import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import Api from 'services/Api'
import { hashTable } from 'services/Utilities'
import { closeModal } from 'store/actions/modals'
import { updateEvents } from 'store/actions/events'
import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { Loading } from 'components/UI'
import { EventSummaryList } from 'components/Schedule'
import { Alert, Card, Checkbox } from 'ui'

import { t } from 'translations'

const ScheduleConfirmChangesModal = ({ modifiedEvents, closeModal, updateEvents }) => {
  const [isSubmitting, setIsSubmitting] = useState()
  const [events, setEvents] = useState()
  const [errorLoading, setErrorLoading] = useState(false)
  const [sendModificationEmails, setSendModificationEmails] = useState(true)

  useEffect(() => {
    const fetchOldEvent = async () => {
      const { result, success } = await Api.post('schedule/schedule/query', {
        shiftIds: modifiedEvents.map(({ id }) => id),
        showCancelledShift: true,
        returnScheduleContactEvents: true,
        markShiftsForLeaveOrVacation: true
      })
      if (!success || !result.length) return setErrorLoading(true)
      setEvents(result)
    }
    fetchOldEvent()
  }, [modifiedEvents])

  const submitUpdateEvents = async () => {
    const eventsById = hashTable(modifiedEvents, 'id')

    setIsSubmitting(true)
    await Api.put('schedule/partial', {
      events: events.map(event => {
        const { start, end, positionId } = eventsById[event._id]
        return { ...event, start, end, positionId }
      }),
      options: { sendModificationEmails }
    })
    closeModal()
  }

  if (!events && !errorLoading) return <Loading />

  return (
    <BaseModal hideButtons title={`manager.schedule.CONFIRM_CHANGE_MODAL`}>
      {errorLoading ? (
        <Alert variant="warning" className="mt-2">
          {t(`manager.schedule.CONFIRM_CHANGE_MODAL.ERROR_LOADING`)}
        </Alert>
      ) : (
        <>
          <EventSummaryList events={events} />
          <Card maxHeight="10rem" className="bg-light mt-2">
            <Card.Body>
              <div className="form-check">
                <Checkbox id="sendModificationEmails" checked={sendModificationEmails} onChange={() => setSendModificationEmails(!sendModificationEmails)} />
                <label className="form-check-label" htmlFor="sendModificationEmails">
                  {t('manager.schedule.CONFIRM_CHANGE_MODAL.SEND_MODIFICATION.LABEL')}
                  <small className="form-text text-muted">{t('manager.schedule.CONFIRM_CHANGE_MODAL.SEND_MODIFICATION.DESCRIPTION')}</small>
                </label>
              </div>
            </Card.Body>
          </Card>
        </>
      )}

      <div className="mt-2">
        {errorLoading ? null : (
          <Button text="actions.CONFIRM" isSubmitting={isSubmitting} className="btn btn-primary mr-2" onClick={() => submitUpdateEvents()} />
        )}
        <Button
          text="actions.CLOSE"
          className="btn btn-outline-secondary"
          onClick={() => {
            if (!errorLoading) updateEvents(events)
            closeModal()
          }}
        />
      </div>
    </BaseModal>
  )
}

const mapStateToProps = ({ resources }) => ({ positionsById: resources.positionsById })
const mapDispatchToProps = dispatch => ({ closeModal: () => dispatch(closeModal()), updateEvents: (...args) => dispatch(updateEvents(...args)) })

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleConfirmChangesModal)
